<script setup lang="ts">
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import SupportContent from "./SupportContent.vue";
</script>

<template>
  <ManagementLayout>
    <template #header>
      <h1>Support</h1>
    </template>
    <SupportContent />
  </ManagementLayout>
</template>
